import {
  SectionDesign,
  SectionDesign_Background,
  SectionDesign_ContainerWidth,
  SectionDesign_InnerShadow,
} from 'app/core/cms/generated/api-types'

export interface ParsedSectionDesign {
  innerShadow: SectionDesign_InnerShadow
  background: SectionDesign_Background
  containerWidth: SectionDesign_ContainerWidth
  padding: {
    top: number
    bottom: number
  }
}

export function parseDesign(dto: SectionDesign | null): ParsedSectionDesign {
  return {
    innerShadow: dto?.innerShadow ?? 'none',
    background: dto?.background ?? 'none',
    containerWidth: dto?.containerWidth ?? 'medium',
    padding: {
      top: parseInt(dto?.padding?.top?.replace('_', '') ?? '64'),
      bottom: parseInt(dto?.padding?.bottom?.replace('_', '') ?? '64'),
    },
  }
}
